import { Box } from '@material-ui/core';
import React from 'react';
import EirActionButton from '../../theme-config/button-theme/EirActionButton';
import styles from './style';

/**
 * @name ActionCTA - Generic CTA component
 * @param {Array} props - CTA data from Strapi
 * @returns {JSX.Element} - CTA's component
 */
const ActionCTA = props => {
    const classes = styles();
    return (
        <Box>
            {props?.cta && props?.cta?.length > 0 && (
                <Box className={classes.ctaContainer}>
                    {props?.cta?.map((item, index) => (
                        <EirActionButton
                            key={index}
                            onClick={() => props.handleAction(item?.action, item?.url)}
                            type={item.type}
                            disabled={props.disablecta || item.disable}
                            variant='buttonMedium'
                        >
                            {item.name}
                        </EirActionButton>
                    ))}
                </Box>
            )}
        </Box>
    );
};

ActionCTA.displayName = 'ActionCTA';
export default ActionCTA;
